module.exports = __webpack_public_path__ + "img/db-callout-logo.3b4e101d.svg";